import actions from './actions'
import mutations from './mutations'
import getters from './getters'

export default {
  state: {
    registeredSchedules: [],
    registeredScheduleOrders: [],
    scheduleOrdersModal: false,
    scheduleDetailsModal: false,
    sendEmailModal: false,
    alterDateModal: false,
    dateConfigModal: false,
    timeScheduleModal: false,
    searchCnpj: '',
    scheduleEditing: false,
    errorSearchCnpj: false,
    errorDisponibilityInterval: false,
    selectedItens: [],
    selectedSchedule: {
      id: '',
      category: '',
      itens: [],
      dates: [],
      status: 0,
      sent: false,
      condominium: {
        id: '',
        cnpj: '',
        name: '',
        address: '',
        addressNumber: '',
        neighborhood: '',
        city: '',
        state: '',
        zipCode: '',
        administrator: ''
      },
      disponibility: {
        capacity: 1,
        interval: null,
        start: null,
        end: null
      },
      code: ''
    },
    alteredSchedule: null,
    loadingCondominium: false,
    loadingSaved: false,
    loadingCanceled: false,
    loadingFinished: false,
    alteredScheduleSaving: false,
    reasons: [],
    searchSchedule: ''
  },
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/agendamento/index.js